// snow-effect.js
(function () {
  const FLOKES_DESKTOP = 45;
  const FLOKES_MOBILE = 20;
  const SEASONAL = true; // true -> only in December; false -> always
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
  }

  function createSnow() {
    // remove existing (prevents duplicates on SPA navigation)
    const existing = document.getElementById('snow-container');
    if (existing) existing.remove();

    const container = document.createElement('div');
    container.id = 'snow-container';
    document.body.appendChild(container);

    const count = isMobile() ? FLOKES_MOBILE : FLOKES_DESKTOP;
    for (let i = 0; i < count; i++) {
      const flake = document.createElement('div');
      flake.className = 'snowflake';
      // size category
      const sizeClass = Math.random() < 0.6 ? 'size-s' : Math.random() < 0.8 ? 'size-m' : 'size-l';
      flake.classList.add(sizeClass);
      // position and animation
      flake.style.left = Math.random() * 100 + '%';
      const duration = (Math.random() * 6 + 6).toFixed(2); // 6s - 12s
      flake.style.animationDuration = duration + 's';
      flake.style.animationDelay = (Math.random() * 10).toFixed(2) + 's';
      // slight horizontal drift via transform and CSS variable for variation
      flake.style.transform = `translateX(0)`;
      container.appendChild(flake);

      // Optional cleanup: when animation ends, re-append for continuous drift (keeps DOM count constant)
      // Not required; the animation is infinite so cleanup isn't necessary.
    }
  }

  function removeSnow() {
    const existing = document.getElementById('snow-container');
    if (existing) existing.remove();
  }

  // Controls: ?snow=on forces it, ?snow=off disables it
  const urlParams = new URLSearchParams(window.location.search);
  const jqSnow = urlParams.get('snow');
  if (jqSnow === 'off') {
    removeSnow();
  } else {
    const alwaysOn = jqSnow === 'on';
    if (alwaysOn || !SEASONAL || new Date().getMonth() === 11) { // December = 11
      // Wait DOM loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', createSnow);
      } else {
        createSnow();
      }
    }
  }
})();